<a nz-dropdown [nzDropdownMenu]="languageMenu" nzTrigger="click" [nzPlacement]="'bottomRight'"
   nz-tooltip nzTooltipPlacement="bottom" [nzTooltipTitle]="'Sprache' | translate" class="m-h-5">
  <i nz-icon nzType="global" nzTheme="outline"></i>
</a>
<nz-dropdown-menu #languageMenu="nzDropdownMenu">
  <ul nz-menu style="max-height: 400px; overflow-y: auto">
    @for (language of languages; track language.code) {
      <li nz-menu-item [nzSelected]="language.code === languageService.currentLanguage" (click)="select(language.code)">
        {{ language.label }}
      </li>
    }
  </ul>
</nz-dropdown-menu>
